import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import i18next from 'i18next';
import { useSelectedDataset } from '../../../../state/hooks/DatastoreHooks';

export const DatastoreMetadataCard = () => {
  const { t } = useTranslation();
  const dataset = useSelectedDataset();

  if (dataset == null) return null;

  return (
    <Grid container spacing={1} direction="column">
      <Grid item>
        <Typography component="span">{t('commoncomponents.datastore.details.metadata.name', 'Nom')}: </Typography>
        <Typography component="span" sx={{ fontWeight: 'bold' }}>
          {dataset.name}
        </Typography>
      </Grid>
      <Grid item>
        <Typography component="span">{t('commoncomponents.datastore.details.metadata.owner', 'Créé par')}: </Typography>
        <Typography component="span" sx={{ fontWeight: 'bold' }}>
          {dataset.ownerName}
        </Typography>
      </Grid>
      <Grid item>
        <Typography component="span">
          {t('commoncomponents.datastore.details.metadata.creationDate', 'Date de création')}:{' '}
        </Typography>
        <Typography component="span" sx={{ fontWeight: 'bold' }}>
          {new Date(dataset.creationDate).toLocaleString(i18next?.resolvedLanguage, {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          })}
        </Typography>
      </Grid>
      {dataset.description && (
        <Grid item>
          <Typography component="span">
            {t('commoncomponents.datastore.details.metadata.description', 'Description')}:{' '}
          </Typography>
          <Typography component="span" sx={{ fontWeight: 'bold' }}>
            {dataset.description}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};
